export type Accumulator = {
    groupNumber: string;
    participantIDNumber: string;
    dependentSequenceNumber: number | null;
    accumulatorDateYear: number;
    accumulatorType: string;
    accumulatorNumber: number;
    codeDescription: string;
    accumulatorAmt: number;
    accumulationType: string;
    accumulatorProduct: string;
    refreshDate: string;
};

export type AccumulatorRequest = {
    groupNumber: string;
    participantIDNumber: string;
};

export type AccumulatorWithDate = Accumulator & {
    lastServiceDate: string;
};

export type MemberAccumulator = {
    dependentSequenceNumber?: number;
    firstName: string;
    groupNumber: string;
    lastName: string;
    middleName: string;
    participantIDNumber: string;
    accumulators: AccumulatorWithDate[];
};

export enum AccumulatorNumbers {
    PlanYearAllowance = 10,
    PlanYearDeductible = 20,
    DentalExams = 30,
    Cleanings = 40,
    XRayBitewing = 50,
    XRayPano = 60,
    Fluoride = 70,
    VisionExams = 150,
    Frames = 160,
    Lenses = 170,
    Contacts = 180,
    // OrthoLifetimeLimit = 300,
}

export const AccumulatorName = {
    [AccumulatorNumbers.PlanYearAllowance]: "Plan Year Allowance",
    [AccumulatorNumbers.PlanYearDeductible]: "Plan Year Deductible",
    [AccumulatorNumbers.DentalExams]: "Exams",
    [AccumulatorNumbers.Cleanings]: "Cleanings",
    [AccumulatorNumbers.XRayBitewing]: "X-Ray Bitewing",
    [AccumulatorNumbers.XRayPano]: "X-Ray Full (Pano)",
    [AccumulatorNumbers.Fluoride]: "Fluoride - Age limits apply",
    [AccumulatorNumbers.VisionExams]: "Exams",
    [AccumulatorNumbers.Frames]: "Frames - Refer to your plan",
    [AccumulatorNumbers.Lenses]: "Lenses (Pair)",
    [AccumulatorNumbers.Contacts]: "Contacts - Refer to your plan",
};
